<fieldset>
  <legend>
    Rectificatif
  </legend>
  <fieldset>
    <legend>
      description
    </legend>
    <app-type-desc-marche [uid]="'_STEP_ID_1' + getUid()" [parentForm]="parentForm" [natureMarche]="rectificatif.natureMarche">
    </app-type-desc-marche>
  </fieldset>

  <!---->

  <fieldset>
    <legend>
      procedure
    </legend>
    <!--app-type-procFNS  [uid]="getUid()" [parentForm]="parentForm" [procedure]="rectificatif.procedure"></app-type-procFNS-->
  </fieldset>

  <!---->

  <fieldset>
    <legend>
      avisInitial
    </legend>
    <app-avis-initial-type [uid]="'_STEP_ID_2' + getUid()" [parentForm]="parentForm" [avisInitial]="rectificatif.avisInitial">
    </app-avis-initial-type>
  </fieldset>

  <!---->

  <button class="btn btn-outline-primary" (click)="addtypeInfosRectif()">Ajouter un typeInfosRectif</button>
  <div *ngFor="let obj of rectificatif.infosRectif; let i = index">
    <fieldset>
      <legend>
        typeInfosRectif {{ i + 1}}
      </legend>
      <button class="btn btn-outline-primary" (click)="removetypeInfosRectif(i)">Supprimer un typeInfosRectif</button>
      <!--app-type-infos-rectif [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [infosRectif]="obj"></app-type-infos-rectif-->
      <app-form-input [parentForm]="parentForm" [value]="obj" [label]="''" [type]="'text'" [rule]=""
        [name]="'_STEP_ID_3' + getUid()+'_index_'+(i+1)">
      </app-form-input>
    </fieldset>
  </div>

</fieldset>